import { IFilterItem } from "..";
import { IAuction, ICorridorDetail } from "../../services";
import {
  AuctionActionCalendarEnum,
  IFetchFiltersAndAuctionCalendarAction,
  IFetchedFiltersAndAuctionCalendarFailedAction,
  IFetchedFiltersAndAuctionCalendarSuccessAction,
  IUpdateAuctionCalendarCorridorFilterValueAction,
  IUpdateAuctionCalendarExchangeFilterValueAction,
  IUpdateAuctionCalendarInterconnectorFilterValueAction,
  IUpdateAuctionCalendarIsShowFilterValueAction,
  IUpdateAuctionCalendarProductFilterValueAction,
} from "./";

export const FetchFiltersAndAuctionCalendarAction = () => {
  return {
    type: AuctionActionCalendarEnum.FetchFiltersAndAuctionCalendar,
    state: { loading: true, initialFilters: { startDateUtc: new Date() } },
  } as IFetchFiltersAndAuctionCalendarAction;
};

export const FetchedFiltersAndAuctionCalendarSuccessAction = (
  data: IAuction[],
  co: ICorridorDetail[]
) => {
  let con = co
    .map((x) => x.corridor)
    .filter((v, i, a) => {
      return v && a.indexOf(v) === i;
    })
    .map((item) => {
      return { value: item, isSelected: true } as IFilterItem;
    });
  let ic = co
    .map((x) => x.interconnector)
    .filter(
      (v, i, a) =>
        v?.toLowerCase() !== "N/A".toLowerCase() && v && a.indexOf(v) === i
    )
    .map((item) => {
      return { value: item, isSelected: true } as IFilterItem;
    });
  let exchanges = data
    .map((x) => x.exchangeCode)
    .filter((v, i, a) => a.indexOf(v) === i)
    .map((item) => {
      return { value: item, isSelected: true } as IFilterItem;
    });
  return {
    type: AuctionActionCalendarEnum.FetchedFiltersAndAuctionCalendarSuccess,
    state: {
      data,
      loading: false,
      initialFilters: {
        corridorKeys: co.map((x) => x.corridorKey),
        corridors: con,
        interconnectors: ic,
        exchanges: exchanges,
      },
    },
  } as IFetchedFiltersAndAuctionCalendarSuccessAction;
};

export const FetchedFiltersAndAuctionCalendarFailedAction = (message: string) => {
  return {
    type: AuctionActionCalendarEnum.FetchedFiltersAndAuctionCalendarFailed,
    state: { loading: false, exceptionMessage: message },
  } as IFetchedFiltersAndAuctionCalendarFailedAction;
};

export const UpateAuctionCalendarCorridorFilterValueAction = (
  currentCorridors: IFilterItem[],
  updateValue: IFilterItem
) => {
  const filtersWithAllCheck = tryAssignAll(currentCorridors, updateValue);

  return {
    type: AuctionActionCalendarEnum.UpdateAuctionCalendarCorridorFilterValue,
    state: { currentFilters: { corridors: filtersWithAllCheck } },
  } as IUpdateAuctionCalendarCorridorFilterValueAction;
};

export const UpateAuctionCalendarProductFilterValueAction = (
  product: IFilterItem[],
  updateValue: IFilterItem
) => {
  const filtersWithAllCheck = tryAssignAll(product, updateValue);
  return {
    type: AuctionActionCalendarEnum.UpateAuctionCalendarProductFilterValue,
    state: {
      currentFilters: { products: filtersWithAllCheck },
    },
  } as IUpdateAuctionCalendarProductFilterValueAction;
};

export const UpateAuctionCalendarIsShowFilterValueAction = (isShow: boolean) => {
  return {
    type: AuctionActionCalendarEnum.UpateAuctionCalendarIsShowFilterValue,
    state: {
      currentFilters: { isShow },
    },
  } as IUpdateAuctionCalendarIsShowFilterValueAction;
};

export const UpateAuctionCalendarInterconnectorFilterValueAction = (
  interconnectors: IFilterItem[],
  updateValue: IFilterItem
) => {
  const filtersWithAllCheck = tryAssignAll(interconnectors, updateValue);

  return {
    type: AuctionActionCalendarEnum.UpateAuctionCalendarInterconnectorFilterValue,
    state: {
      currentFilters: { interconnectors: filtersWithAllCheck },
    },
  } as IUpdateAuctionCalendarInterconnectorFilterValueAction;
};

export const UpdateAuctionCalendarExchangeFilterValueAction = (
  exchanges: IFilterItem[],
  updateValue: IFilterItem
) => {
  const filtersWithAllCheck = tryAssignAll(exchanges, updateValue);
  return {
    type: AuctionActionCalendarEnum.UpdateAuctionCalendarExchangeFilterValue,
    state: {
      currentFilters: { exchanges: filtersWithAllCheck },
    },
  } as IUpdateAuctionCalendarExchangeFilterValueAction;
};

const tryAssignAll = (
  filters: IFilterItem[],
  selectedFilterItem: IFilterItem
): IFilterItem[] => {
  return filters?.map((x) => {
    if (selectedFilterItem.value.toLowerCase() === "All".toLowerCase()) {
      x.isSelected = selectedFilterItem.isSelected;
    }

    if (x.value === selectedFilterItem.value) {
      return selectedFilterItem;
    }
    return x;
  });
};


